<!--
    描述：主体
    日期：2021/04/06
    作者：zwh
-->
<template>
    <div class="h100">
        <!--
        <div class="w-table-layout">
            <div class="w-table-content" ref="treeContent" style=" overflow-y: auto; border:1px solid #eee">
                <el-tree ref="menusTree"
                         :height="treeData.tableH"
                         :data="treeData.tableData"
                         :props="defaultProps"
                         :expand-on-click-node="false"
                         :highlight-current="true"
                         default-expand-all
                         show-checkbox
                         :check-strictly="true"
                         node-key="id"
                         :default-checked-keys="treeDefaultCheckedKey"
                ></el-tree>
            </div>
        </div>
        -->
        <div class="w-page-main">
            <div class="w-page-header superiors-search-area">
                <div class="left-text overflow-hidden">
                    <span><b>主体列表</b></span>
                </div>
                <div class="btnGroups">
                    <el-button type="primary"
                        size="small"
                        @click="saveClick('tenant_limit')"
                        v-if="roleBtns.includes('tenant_limit_save')">保存</el-button>
                </div>
            </div>
            <div class="w-page-container pdb10">
                <div class="w-table-layout">
                    <div class="w-table-content" ref="treeContent" style=" overflow-y: auto; border:1px solid #eee">
                        <el-tree ref="menusTree"
                                 :height="treeData.tableH"
                                 :data="treeData.tableData"
                                 :props="defaultProps"
                                 :expand-on-click-node="false"
                                 :highlight-current="true"
                                 default-expand-all
                                 show-checkbox
                                 :check-strictly="true"
                                 node-key="id"
                                 :default-checked-keys="treeDefaultCheckedKey"
                        ></el-tree>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import { selectAll } from 'api/system/roleLimit.js'
import { saveOrUpdate,getTenantSubject } from 'api/system/sysTenantLimit.js'
export default {
    name : '',
    components: {

    },
    data() {
        return {
            //租户id
            tenantId : '',
            //默认选中信息
            treeDefaultCheckedKey: [],

            treeData: {
                loading: false,
                tableH: 200,
                tableData: [],

                tableOriData: [],
                tableByRoleData: [],
            },

            defaultProps: {
                children: 'children',
                label: 'sname'
            },
        }
    },
    // 缓存页面进入时
    activated() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.treeData.tableH = this.$refs.treeContent.offsetHeight
            }, 100)
        })
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.treeData.tableH = this.$refs.treeContent.offsetHeight
            }, 100)
        })
    },
    computed: {
        ...mapState('app', { clientSize: state => state.clientSize }),
        ...mapState('menu', {
            roleBtns: state => state.roleBtns
        })
    },
    watch: {
        clientSize(val) {
            this.treeData.tableH = this.$refs.treeContent.offsetHeight
        }
    },
    created() {
        //获取主体信息
        this.getSubject()
    },
    methods: {
        //保存点击事件
        saveClick(type) {
            this.doSave()
        },
        //获取主体信息
        getSubject(){
            let that = this
            selectAll({}).then(res => {
                if(res.operationCode == 1) {
                    that.treeData.tableData = that.$utils.toArrayTree(res.data.limits)
                }

            })
        },
        //获取已选中的主体信息
        getTenantSubject(obj){
            let that = this
            that.treeDefaultCheckedKey = []
            if(obj== '') {
                that.tenantId = ''
                return
            }
            that.tenantId = obj.id
            let param = {
                tenantId : that.tenantId
            }
            getTenantSubject(param).then(res => {
                if(res.operationCode == 1) {
                    that.treeDefaultCheckedKey = res.data
                }
            })
        },
        //保存
        doSave(){
            let that = this
            if(that.tenantId == '') {
                that.$message({message: '请选择单位信息！', type: 'warning'});
                return
            }
            let checkSelection = this.$refs.menusTree.getCheckedKeys().concat()
            let param = {
                tenantId: that.tenantId,
                limitIdsSelection: checkSelection
            }
            saveOrUpdate(param).then(res => {
                if(res.operationCode==1){
                    that.$message({message: '保存成功！', type: 'success'});
                }
            })
        },
        //点击接地单
        nodeClick(obj) {
            this.$emit('row-click', obj)
        },
        //初始方法
        setBaseInfo(obj){
            this.tenantId = obj.id
            this.getSubject()
            this.getTenantSubject(obj)
        },
    }
}
</script>
<style lang="less" scoped>
.tree-content {
	overflow-y: auto;
	padding: 5px 0px;
}
.w-table-page {
	padding-bottom: 5px;
}
</style>